import type { TimeRange } from '@/shared/charts/time-series-chart/TimeSeriesChart.types';

/** `[start, end]` in epoch milliseconds. */
export type TimeDomain = [number, number];

export function toTimeDomain({ startTimestamp, endTimestamp }: TimeRange): TimeDomain {
  return [startTimestamp, endTimestamp];
}
